// extracted by mini-css-extract-plugin
export var container = "health-module--container--NVVq9";
export var flex = "health-module--flex--e5eIP";
export var health_features_container = "health-module--health_features_container--AOq5Y";
export var img = "health-module--img--Us--P";
export var item = "health-module--item--CGI3L";